import { useState } from 'react';
import ApprovalSequenceList from '../../components/admin/approvals/ApprovalSequenceList';
import ApprovalSequenceForm from '../../components/admin/approvals/ApprovalSequenceForm';
import Button from '../../components/shared/UI/Button';

export default function ApprovalSequencesPage() {
  const [view, setView] = useState('list');
  const [selectedSeq, setSelectedSeq] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  function handleSaved() {
    setView('list');
    setSelectedSeq(null);
    setRefreshKey(k => k + 1);
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Approval Sequences</h1>
          <p>Configure IIC approval sequences per fund. Default: Head of Pipeline → CIO → MD.</p>
        </div>
      </div>

      {view === 'list' && (
        <ApprovalSequenceList
          key={refreshKey}
          onAdd={() => { setSelectedSeq(null); setView('add'); }}
          onEdit={(seq) => { setSelectedSeq(seq); setView('edit'); }}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedSeq(null); }}>
              ← Back to Sequences
            </Button>
          </div>
          <div className="card">
            <div className="card-header">
              <h2>{view === 'add' ? 'New Approval Sequence' : `Edit: ${selectedSeq?.name}`}</h2>
            </div>
            <div className="card-body">
              <ApprovalSequenceForm
                sequence={view === 'edit' ? selectedSeq : null}
                onSaved={handleSaved}
                onCancel={() => { setView('list'); setSelectedSeq(null); }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
